var $ = require("jquery");

(function () {

    const $trigger = $("[data-countup]");
    const $counters = $trigger.find("[data-countup-target]");
    let isTriggered = false;

    const init = () => {
        $counters.each(function () {
            const $this = $(this);
            const countUp = () => {
                const currentCount = parseInt($this.text())
                const countTarget = parseInt($this.data("countupTarget"));
                const increment = countTarget > 200 ? Math.trunc(countTarget / 100) : 1;

                if (currentCount < countTarget) {
                    if ((currentCount + increment) > countTarget)
                        $this.text(countTarget);
                    else
                        $this.text(currentCount + increment);

                    setTimeout(countUp, 10);
                }
            };
            countUp();
        });
    };

    const observer = new IntersectionObserver((el) => {
        if (el[0].isIntersecting && !isTriggered) {
            isTriggered = true;
            init();
        }
    }, { threshold: [0.8] })

    if ($trigger.length > 0) {
        observer.observe($trigger[0]);
    }

})();